import {
  ActionType,
  useNotificationDispatch,
  useNotificationState
} from '../../providers/NotificationProvider';
import { RemoveAction } from '../../providers/NotificationProvider/state';
import Notification from './Notification';

const NotificationGroup = () => {
  const { notifications } = useNotificationState();
  const dispatch = useNotificationDispatch();

  const notificationItems = notifications.map(({ id, ...rest }): any => (
    <Notification
      key={id}
      {...rest}
      onClose={() => dispatch(new RemoveAction(id))}
    />
  ));

  return <>{notificationItems}</>;
};

export default NotificationGroup;
